/* unplugin-vue-components disabled */import script from "./ChannelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelList.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelList.vue?vue&type=style&index=0&id=bbd6d83c&lang=less"

const __exports__ = script;

export default __exports__